function init_selects() {

    //Custom selects selector
    var $selects = $('select.form-select:not(.no-touchy):not(.creatable)');

    //Initialise custom select inputs
    $selects.chosen({
        width: 'auto',
        disable_search_threshold: 10,
        persistent_create_option: false
    });

}

$(function() {
    //Initialise custom select inputs
    init_selects();
});
